import { Link, useLocation } from 'react-router-dom';
import { ChevronRight, Menu, Search } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { buildBreadcrumbs } from '@/lib/nav';

export function Topbar({ onMenu, onSearch }: { onMenu: () => void; onSearch: () => void }) {
  const crumbs = buildBreadcrumbs(useLocation().pathname);
  return (
    <header className="flex h-14 shrink-0 items-center gap-3 border-b bg-background px-4 md:px-6">
      <Button variant="ghost" size="icon" className="md:hidden" onClick={onMenu} aria-label="Open menu">
        <Menu />
      </Button>
      <nav aria-label="Breadcrumb" className="min-w-0 flex-1">
        <ol className="flex items-center gap-1.5 text-sm text-muted-foreground">
          {crumbs.map((c, i) => (
            <li key={c.to} className="flex min-w-0 items-center gap-1.5">
              {i > 0 && <ChevronRight className="size-3.5 shrink-0" aria-hidden />}
              {i === crumbs.length - 1 ? (
                <span className="truncate font-medium text-foreground" aria-current="page">{c.label}</span>
              ) : c.link ? (
                <Link to={c.to} className="truncate hover:text-foreground">{c.label}</Link>
              ) : (
                <span className="truncate text-muted-foreground">{c.label}</span>
              )}
            </li>
          ))}
        </ol>
      </nav>
      <Button variant="outline" size="sm" onClick={onSearch} className="gap-2 text-muted-foreground">
        <Search className="size-4" aria-hidden />
        <span className="sr-only sm:not-sr-only">Search</span>
        <kbd className="hidden rounded border bg-muted px-1.5 font-mono text-[10px] sm:inline">⌘K</kbd>
      </Button>
    </header>
  );
}
